/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useState } from "react";
import * as API from "../../http/api";
import { closelightbox } from "../../util/Functions";
import { Grid, Button, DialogActions, DialogContent, Dialog, DialogTitle, IconButton } from "@mui/material";
import { ModalStyle } from "../../util/Styles";
import { Close } from "@mui/icons-material";

const InfoValidation = (props) => {
  const [zPos, setZPos] = useState(45)

  const getPath = (data) => {
    let pos = data.indexOf("evidence");
    let sub = "";
    if (pos > -1) {
      sub = data.substring(pos, data.length);
    }
    return sub;
  };

  const getName = (data) => {
    let name = "";
    let parts = data.split("/");
    name = parts[parts.length - 1];
    return name;
  };

  const downloadFile = async (data) => {
    let path = getPath(data);
    props.changeLoader(true);
    setZPos(-1)
    if (path) {
      let request = await API.service( "downloadFile", path, props.pos, props.changeAlert, props.changeLoader, props.history );
      if (request.status == 200 && request.data.data.response == "OK") {
        window.open(request.data.data.content, "Download");
      }
    }
    props.changeLoader(false);
    setZPos(45)
  };

  return (
    <Dialog open={true} sx={{zIndex: zPos, filter: zPos !== 45 ? 'blur(2px)': "none" }} fullWidth>
      <ModalStyle property={String(false)}>
        <DialogTitle>
          Validación de: <h3 id="subtitle">{props.name}</h3>
          <IconButton id="headButton" onClick={closelightbox}><Close/></IconButton>
        </DialogTitle>
        
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={3} >Agente</Grid>
            <Grid item xs={9} ><label>{props.content.name}</label></Grid>	
            <Grid item xs={3} >Email</Grid>	
            <Grid item xs={9} ><label>{props.content.email}</label></Grid>	
            {props.files.length > 0 && 
              <>
                <Grid item xs={3} >Evidencias</Grid>	
                <Grid item xs={9} >
                {props.files.map((item, index) => {
                  return [
                    <a href="#" data-tag="allowRowEvents" key={`file-${index}`} onClick={downloadFile.bind(this, item)} >
                      {getName(item)}
                    </a>,
                    <br key={`file-br-${index}`} />,
                  ];
                })}
                </Grid>	
              </>
            }
          </Grid>
        </DialogContent>

        <DialogActions>					
          <Button variant="contained" onClick={closelightbox}>Aceptar</Button>
        </DialogActions>
      </ModalStyle>
    </Dialog>
  );
};

export default InfoValidation;
